import React, { useState, useEffect } from 'react';
import './DeleteModal.css';

function DeleteModal({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  title = 'Delete',
  confirmButtonText = 'Delete',
  error = null,
  entityType = 'item'
}) {
  const [deleteNumbers, setDeleteNumbers] = useState(['', '', '']);

  // Reset delete numbers when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setDeleteNumbers(['', '', '']);
    }
  }, [isOpen]);

  const handleNumberChange = (index, value) => {
    const newNumbers = [...deleteNumbers];
    newNumbers[index] = value.replace(/\D/g, '');
    setDeleteNumbers(newNumbers);
  };

  const handleInputChange = (e, index) => {
    handleNumberChange(index, e.target.value);
    if (e.target.value && index < 2) {
      e.target.nextElementSibling?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !deleteNumbers[index] && index > 0) {
      e.target.previousElementSibling?.focus();
    }
  };

  const handleSubmit = () => {
    const confirmationCode = deleteNumbers.join('');
    if (confirmationCode.length !== 3) {
      return;
    }
    onConfirm(confirmationCode);
  };

  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal delete-modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-header">
          <h2>{title}</h2>
          <button className="delete-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="delete-modal-body">
          <p className="delete-warning">
            Are you sure you want to delete the {entityType} <strong>{itemName}</strong>?
          </p>
          <p className="delete-confirm-text">
            Please enter 3 random digits to confirm deletion:
          </p>
          <div className="delete-inputs">
            {[0, 1, 2].map((index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="delete-digit"
                value={deleteNumbers[index]}
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            ))}
          </div>
          {error && <p className="delete-error-text">{error}</p>}
        </div>
        <div className="delete-modal-footer">
          <button 
            type="button" 
            className="delete-btn delete-btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="delete-btn delete-btn-danger"
            onClick={handleSubmit}
            disabled={deleteNumbers.join('').length !== 3}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;

